import React, { useEffect, useState } from 'react';
import { Link, NavLink, useParams } from 'react-router-dom';
import BuyoutAndForecasting from '../../components/BuyoutAndForecasting';
import { getJson } from '../helpers';
import ClaretProjectToolEmbed from './ClaretProjectToolEmbed';

export default function ForecastingPage({ tab = 'revenue' }) {
  const { projectVuid } = useParams();
  const [projectName, setProjectName] = useState('');
  const base = `/procore/projects/${projectVuid}/buyout-forecasting`;

  useEffect(() => {
    let cancelled = false;
    getJson(`/api/projects/${projectVuid}`)
      .then((project) => {
        if (!cancelled && project?.project_name) setProjectName(project.project_name);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [projectVuid]);

  return (
    <div className="pc-page pc-forecast-page">
      <div className="pc-crumb">
        <Link to="/procore">Portfolio</Link>
        {' / '}
        <Link to={`/procore/projects/${projectVuid}`}>{projectName || 'Project'}</Link>
        {' / '}
        Forecasting
      </div>
      <div className="pc-title-row">
        <h1>Forecasting</h1>
      </div>
      <div className="pc-subnav">
        <NavLink
          to={`${base}?project=${projectVuid}`}
          end
          className={({ isActive }) => (isActive || tab === 'revenue' ? 'pc-subnav-active' : '')}
        >
          Revenue Forecasting
        </NavLink>
        <NavLink to={`${base}/cost?project=${projectVuid}`}>Cost Forecasting</NavLink>
      </div>
      <ClaretProjectToolEmbed
        title={tab === 'cost' ? 'Cost Forecasting' : 'Revenue Forecasting'}
        projectVuid={projectVuid}
        hideChrome
      >
        <BuyoutAndForecasting view={tab === 'cost' ? 'cost' : 'revenue'} />
      </ClaretProjectToolEmbed>
    </div>
  );
}
